export function renderValue(
    item: any,
    isFirst?: boolean,
    pricing?: any,
    values?: any
) {
    const {
        type,
        somos_code,
        mounter,
        model,
        month_reference,
        year,
        year_reference,
        aggregates_1,
        aggregates_2,
        description,
        vehicle_type,
        value,
    } = item;

    const codigo_fipe = (aggregates_1?.codigo_fipe || aggregates_2?.DsCodigo) ?? '-';
    // const DsCombustivel = (aggregates_1?.combustivel || aggregates_2?.DsCombustivel) ?? '-';
    const month = month_reference ?? '-';
    const yearReference = year_reference ?? '-';
    const formattedValue =
        value != null
            ? `R$ ${Number(value).toLocaleString('pt-BR', {
                minimumFractionDigits: 0,
                maximumFractionDigits: 0,
            })}*`
            : 'Valor indisponível';

    if (pricing && type !== '5') {
        return (
            <>
                <tr style={{ backgroundColor: '#c9f0ff' }}>
                    <td className="no-border">CÓDIGO SOMOS</td>
                    <td>{somos_code ?? '-'}</td>
                </tr>
                {/* <tr>
                    <td className="no-border">MÊS/ANO DE REFERÊNCIA</td>
                    <td>
                        {month === '-' || yearReference === '-' ? '-' : `${month}/${yearReference}`}
                    </td>
                </tr> */}
                <tr>
                    <td className="no-border">DESCRIÇÃO</td>
                    <td>{description ?? '-'}</td>
                </tr>
                <tr>
                    <td className="no-border">PREÇO MÉDIO</td>
                    <td>{formattedValue}</td>
                </tr>
                {/* <tr>
                    <td className="no-border">EIXOS</td>
                    <td>{axis ?? '-'}</td>
                </tr>
                <tr>
                    <td className="no-border">
                        DATA DA CONSULTA
                    </td>
                    <td >{date_time ?? '-'}</td>
                </tr> */}
                {/* <tr>
                    <td className="no-border">MODELO</td>
                    <td>{model ?? '-'}</td>
                </tr> */}
            </>
        );
    }

    if (pricing && type === '5') {
        return (
            <>
                <tr style={{ backgroundColor: '#c9f0ff' }}>
                    <td className="no-border">CÓDIGO FIPE</td>
                    <td>{codigo_fipe}</td>
                </tr>
                {/* <tr>
                    <td className="no-border">MÊS/ANO DE REFERÊNCIA</td>
                    <td>
                        {month === '-' || yearReference === '-' ? '-' : `${month}/${yearReference}`}
                    </td>
                </tr> */}
                <tr>
                    <td className="no-border">DESCRIÇÃO</td>
                    <td>{description ?? '-'}</td>
                </tr>
                <tr>
                    <td className="no-border">PREÇO MÉDIO</td>
                    <td>{type === '5' ? `R$ ${Number(values[0].value).toLocaleString('pt-BR', { minimumFractionDigits: 0, maximumFractionDigits: 0 })}` : formattedValue}
                    </td>                
                </tr>
            </>
        );
    }

    if (!pricing) {
        return (
            <>
                <tr>
                    <td className="no-border">{type === '5' ? 'CÓDIGO FIPE' : 'CÓDIGO SOMOS'}</td>
                    <td>{(somos_code || codigo_fipe) ?? '-'}</td>
                </tr>
                <tr>
                    <td className="no-border">MÊS/ANO DE REFERÊNCIA</td>
                    <td>
                        {month === '-' || yearReference === '-' ? '-' : `${month}/${yearReference}`}
                    </td>
                </tr>
                <tr>
                    <td className="no-border">FABRICANTE</td>
                    <td>{mounter ?? '-'}</td>
                </tr>
                <tr>
                    <td className="no-border">MODELO</td>
                    <td>{model ?? '-'}</td>
                </tr>
                <tr>
                    <td className="no-border">DESCRIÇÃO</td>
                    <td>{description ?? '-'}</td>
                </tr>
                {type === "7" &&
        
                    <tr>
                        <td className="no-border">TIPO DE VEÍCULO</td>
                        <td>{vehicle_type ?? '-'}</td>
                    </tr>
                }
                {type !== '7' && 
                    <tr>
                        <td className="no-border">ANO</td>
                        <td>{year ?? '-'}</td>
                    </tr>
                }
                {/* {type !== '5' && 
                    <tr>
                        <td className="no-border">PREÇO MÉDIO</td>
                        <td>{formattedValue}</td>
                    </tr>
                } */}
            </>
        );
    }

    return null;
}
